import type { ComponentProps } from 'react'
import { type Control, useFormState } from 'react-hook-form'
import { SubmitButton } from '#src/components/core/form/SubmitButton.tsx'

export function FormSubmitButton({
  control,
  ...delegated
}: {
  control: Control<any>
} & ComponentProps<typeof SubmitButton>) {
  const { isSubmitting, disabled } = useFormState({ control })
  return (
    <SubmitButton
      submitting={isSubmitting}
      disabled={disabled}
      {...delegated}
    />
  )
}
